import { render, staticRenderFns } from "./addSurvey.vue?vue&type=template&id=018e8c0a&scoped=true"
import script from "./addSurvey.vue?vue&type=script&lang=js"
export * from "./addSurvey.vue?vue&type=script&lang=js"
import style0 from "./addSurvey.vue?vue&type=style&index=0&id=018e8c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e8c0a",
  null
  
)

export default component.exports